const { platform, userAgent } = window.navigator

// Device specific checks
const device = {
    isTouch: () => 'ontouchstart' in document.documentElement,
}

// Operating system specific checks
const os = {
    isIOS: () => /iP(hone|ad|od)/ig.test(platform),
    isAndroid: () => /android/ig.test(userAgent)
}

// Browser specific checks
const browser = {
    isIe: () => /(Trident|Edge)/ig.test(userAgent),
    isIe11: () => /rv:11/.test(userAgent),
    isFirefox: () => /firefox/ig.test(userAgent),
    isChrome: () => /chrome/ig.test(userAgent)
}


// Array of checks to perform when generating css identifiers
const _features = [
    { matches: device.isTouch, cssClass: 'ps-is-touch' },
    { matches: os.isIOS, cssClass: 'ps-is-ios' },
    { matches: os.isAndroid, cssClass: 'ps-is-android' },
    { matches: browser.isIe, cssClass: 'ps-is-ie' },
    { matches: browser.isIe11, cssClass: 'ps-is-ie11' },
    { matches: browser.isFirefox, cssClass: 'ps-is-firefox' },
    { matches: browser.isChrome, cssClass: 'ps-is-chrome' }
]

/**
 * Given an array of matched conditions returns a string of css classes
 * @returns {Array}
 */
  // TODO: Fix odd compile behaviour occuring where filter is always returning an array of objects instead of strings

const getCssClasses = () => _features.filter(feature => {
    if (feature.matches()) return feature.cssClass
})

const FeatureDetection = {
    os,
    device,
    browser,
    getCssClasses
}

export default FeatureDetection



// WEBPACK FOOTER //
// ./js/utils/FeatureDetection.js